import { Message, MessageBox } from 'element-ui'
import { isPC } from '@/utils'

const install = function(Vue) {
  const bus = new Vue({
    methods: {
      emit(event, ...args) {
        this.$emit(event, ...args)
      },
      on(event, cb) {
        this.$on(event, cb)
      },
      off(event, cb) {
        this.$off(event, cb)
      },
      delay(cb, time) {
        setTimeout(cb, time || 1000)
      },
      tip(msg = '操作成功！', type = 'info', time = 2000, ctrl = true) {
        if (isPC()) {
          Message({
            message: msg,
            showClose: ctrl,
            duration: time,
            type: type,
            customClass: 'tip-message',
          })
        } else {
          if (type !== 'success') {
            type = 'fail'
          }
          this.$toast({
            type: type,
            message: msg,
            duration: time || 1000,
          })
        }
      },
      async open(cb) {
        try {
          await MessageBox.confirm('您确定要删除吗? 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          cb()
        } catch (err) {
          console.log(err)
        }
      },
    },
  })
  Vue.prototype.$vgo = bus
}

export default install
